import { useCallback, useMemo } from 'react';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import { useBaseUrlMiddleware } from '@cbhq/identity-shared/hooks';

import { useMockMiddleware } from '../external/middleware';
import { getFetchClient } from '../external/utils';
import { mockGetProfileMenu, mockGetProfileMenuV2 } from '../mocks/mocks';
import { useClientProps } from '../providers/ClientPropsProvider';
import { unauthorizedErrorMiddleware } from '../utils/unauthorizedErrorMiddleware';

import { useAnalytics } from './useAnalytics';

const handlers = {
  '/api/v1/profile-menu': mockGetProfileMenu,
  '/api/v2/profile-menu': mockGetProfileMenuV2,
};

export function useFetchWithMiddleware() {
  const { onUnauthorized, target, projectId } = useClientProps();
  const mockFetch = useMockMiddleware(handlers, undefined, projectId);
  const authedFetch = getFetchClient();

  const { logEvent } = useAnalytics();

  const baseUrlMiddleware = useBaseUrlMiddleware(target);

  const handleUnauthorized = useCallback(
    (error: Error) => {
      logEvent('profile_menu_unauthorized', {
        action: ActionType.api,
        componentType: ComponentType.dropdown,
        error: error.message,
      });
      onUnauthorized?.();
    },
    [onUnauthorized, logEvent],
  );

  const fetchFunction = useMemo(
    () => (target === 'mock' ? mockFetch() : authedFetch),
    [authedFetch, mockFetch, target],
  );

  return baseUrlMiddleware(unauthorizedErrorMiddleware(fetchFunction, handleUnauthorized));
}
